'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactElement, useEffect, useId, useRef, useState } from 'react';
import styles from './icecat-product-story.component.module.scss';
import { toIcecatLang } from '@spa/lib/utils/icecatLocale';
export interface Props {
  readonly ean: string | null;
  readonly locale: string;
  readonly code: string | null;
}
function IcecatProductStoryComponent(t0) {
  const $ = _c(18);
  const {
    ean,
    locale,
    code
  } = t0;
  const [showSyndigo, setShowSyndigo] = useState(!ean);
  let t1;
  if ($[0] !== ean || $[1] !== locale) {
    t1 = {
      ean,
      locale
    };
    $[0] = ean;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [propSnapshot, setPropSnapshot] = useState(t1);
  if (ean !== propSnapshot.ean || locale !== propSnapshot.locale) {
    setPropSnapshot({
      ean,
      locale
    });
    setShowSyndigo(!ean);
  }
  const containerRef = useRef(null);
  const reactId = useId();
  let t2;
  if ($[3] !== reactId) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /:/g;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = reactId.replace(t3, "");
    $[3] = reactId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const wrapperId = `icecat-story${t2}`;
  let t3;
  let t4;
  if ($[6] !== ean || $[7] !== locale) {
    t3 = () => {
      if (!ean) {
        return;
      }
      let cancelled = false;
      const init = async () => {
        const container = containerRef.current;
        if (!container || cancelled) {
          return;
        }
        container.innerHTML = "";
        const liveStory = new LiveStory({
          gtin: ean,
          lang: toIcecatLang(locale),
          username: "CatMan-Mueller"
        });
        const isExist = await liveStory.exist();
        if (cancelled) {
          return;
        }
        if (isExist) {
          await liveStory.insert(`#${container.id}`);
        } else {
          setShowSyndigo(true);
        }
      };
      if (typeof LiveStory !== "undefined") {
        init();
      } else {
        const handler = () => {
          init();
          window.removeEventListener("liveStoryReady", handler);
        };
        window.addEventListener("liveStoryReady", handler);
        return () => {
          cancelled = true;
          window.removeEventListener("liveStoryReady", handler);
        };
      }
      return () => {
        cancelled = true;
      };
    };
    t4 = [ean, locale];
    $[6] = ean;
    $[7] = locale;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== wrapperId) {
    t5 = <div id={wrapperId} ref={containerRef} />;
    $[10] = wrapperId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== code || $[13] !== showSyndigo) {
    t6 = showSyndigo && <syndigo-powerpage pageid={code} />;
    $[12] = code;
    $[13] = showSyndigo;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className={styles["icecat-product-story"]}>{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
export default IcecatProductStoryComponent;